import { useState, useEffect, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import TerminalDialog from './terminal/terminalDialog'
import MainCard, {
  ShowNoRecordsFound,
  SnackBarHideDuration,
  SnackBarTransition,
  ErrorScreen
} from '../../utils/ui_utils'
import { Add as AddIcon, FileCopyOutlined } from '@mui/icons-material'
import { businessCheck } from '../../utils/utils'
import {
  Button,
  Grid,
  Snackbar,
  Card,
  Divider,
  Typography,
  Alert as MuiAlert,
  Pagination,
  CardContent,
  Box,
  Chip,
  IconButton,
  TextField
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import UserTypeShimmerWithoutAvatar from '../../utils/ui_components/shimmers/userTypeShimmerWithoutAvatar'
import { useFetchOutlet } from '../../modules/outlet/outletHooks'
import {
  useCreateTerminalOnline,
  useFetchTerminalOnline,
  useUpdateTerminalOnline
} from '../../modules/terminals/terminalOnlineHooks'
import { useFetchAppFlavour } from '../../modules/appFlavours/appFlavourHooks'
import moment from 'moment/moment'

function Terminal() {
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [terminalData, setTerminalData] = useState(null)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(15)
  const [pagecount, setPageCount] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [terminalDrawerMode, setterminalDrawerMode] = useState('edit')
  const [terminalDrawerVisibility, setTerminalDrawerVisibility] =
    useState(false)
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [terminals, setTerminals] = useState([])
  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } =
    useFetchOutlet()
  const { createTerminalOnline } = useCreateTerminalOnline()
  const {
    fetchTerminalOnline,
    fetchTerminalOnlineData,
    fetchTerminalOnlineError,
    fetchTerminalOnlineLoading
  } = useFetchTerminalOnline()
  const { updateTerminalOnline } = useUpdateTerminalOnline()
  const {
    getAppsForTerminalLoading,
    getAppsForTerminalData,
    getAppsForTerminalError,
    getAppsForTerminal
  } = useFetchAppFlavour()

  const handlePageChange = async (event, value) => {
    setPage(value)
    let payLoad = {
      pageNumber: value,
      limit: limit
    }
    fetchTerminalOnline(payLoad)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (value === '' || /^\d+$/.test(value)) {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const history = useNavigate()
  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  useEffect(() => {
    businessCheck(history)
    let payLoad = {
      pageNumber: 1,
      limit: 1000
    }
    outletFetch(payLoad)
    fetchTerminalOnError()
    getAppsForTerminal()
  }, [])

  useEffect(() => {
    if (fetchTerminalOnlineData.data?.length > 0) {
      pageCount(fetchTerminalOnlineData.total)
    }
  }, [fetchTerminalOnlineData])

  // const handleCopyActivationKey = (key) => {

  // };
  const TerminalListUI = ({ terminal, index }) => {
    //  let selectedindex;
    //   let copySuccess = false;

    return (
      <MainCard
        onClick={() => {
          setterminalDrawerMode('edit')
          setTerminalDrawerVisibility(true)
          let terminalInfo = _.cloneDeep(terminal)
          if (!terminalInfo.outlet) terminalInfo.outlet_id = ''
          setTerminalData(terminalInfo)
        }}
        sx={{
          mt: 1,
          p: 2,
          alignItems: 'center',
          transition: 'box-shadow 0.3s ease',
          borderRadius: 1,
          '&:hover': {
            boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <Grid container spacing={1}>
          <Grid item md sm>
            <Grid container direction="column" sx={{ cursor: 'pointer' }}>
              <Grid item>
                <Typography mb={1} variant="h6" sx={{ fontWeight: 'bold' }}>
                  {terminal?.name}
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  In{' '}
                  <Chip
                    label={
                      terminal?.outlet?.name +
                      ' | ' +
                      terminal?.outlet?.sub_business_name
                    }
                  />
                </Typography>
                <Grid item>
                  {terminal?.serial_number ? (
                    <Typography
                      variant="body1"
                      sx={{ color: 'text.secondary' }}
                    >
                      SL No : {terminal?.serial_number}
                    </Typography>
                  ) : (
                    <Typography>&nbsp;</Typography>
                  )}
                </Grid>
                {terminal?.app_flavor?.flavor_name ? (
                  <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                    For {terminal?.app_flavor?.flavor_name}
                  </Typography>
                ) : (
                  <Typography>&nbsp;</Typography>
                )}
                {terminal?.active ? (
                  <>
                    {terminal?.activated_on && (
                      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                        Activated on: {moment(terminal?.activated_on).format('DD-MM-YYYY')}
                      </Typography>
                    )}
                    <Typography
                      variant="body1"
                      sx={{
                        color: moment(terminal?.expiry_date).isBefore(moment())
                          ? 'red'
                          : 'green'
                      }}
                    >
                      {moment(terminal?.expiry_date).isBefore(moment())
                        ? 'Expired: '
                        : 'Subscription ends on: '}
                      {moment(terminal?.expiry_date).format('DD-MM-YYYY')}
                    </Typography>
                    {terminal?.warranty_expiry_date && (
                      <Typography
                        variant="body1"
                        sx={{
                          color: moment(terminal?.warranty_expiry_date).isBefore(moment())
                            ? 'red'
                            : 'text.secondary'
                        }}
                      >
                        {moment(terminal?.warranty_expiry_date).isBefore(moment())
                          ? 'Warranty expired: '
                          : 'Warranty expires on: '}
                        {moment(terminal?.warranty_expiry_date).format('DD-MM-YYYY')}
                      </Typography>
                    )}
                  </>
                ) : (
                  <Typography>&nbsp;</Typography>
                )}
              </Grid>

              <Typography
                variant="subtitle1"
                sx={{ pt: 1, color: '#379237' }}
                gutterBottom
              >
                {terminal?.activation_key.toString()}
                {
                  <IconButton
                    size="small"
                    aria-label="Copy Activation Key"
                    onClick={(event) => {
                      event.stopPropagation()
                      navigator.clipboard.writeText(
                        terminal?.activation_key.toString()
                      )
                      toastMessage('Activation Key Copied', 'success')
                    }}
                    sx={{ ml: 1, color: '#757575' }}
                  >
                    <FileCopyOutlined />
                  </IconButton>
                }

                {/* {copySuccess && <Typography variant="caption" sx={{ color: 'success', ml: 1 }}>Copied!</Typography>} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent="flex-end"
            onClick={() => {
              setterminalDrawerMode('edit')
              setTerminalDrawerVisibility(true)
              setTerminalData(terminal)
            }}
          >
            <Chip
              size="small"
              label={terminal?.active ? 'Activated' : 'Not Activated'}
              color={terminal?.active ? 'success' : 'error'}
            />
          </Grid>
        </Grid>
      </MainCard>
    )
  }

  const fetchTerminalOnError = () => {
    let payLoad = {
      pageNumber: page,
      limit: limit
    }
    fetchTerminalOnline(payLoad)
  }

  return (
    <>
      <Helmet title="Online Terminals" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item md={6}>
          <Typography variant="h4" gutterBottom display="inline">
            Online Terminals
          </Typography>
        </Grid>
        <Grid item>
          {/* <Button
            startIcon={<AddIcon />}
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              if (outletFetchData.data?.length > 0) {
                setterminalDrawerMode('new')
                setTerminalDrawerVisibility(true)
                setTerminalData({
                  name: '',
                  outlet_id: '',
                  app_flavor_id: ''
                })
              } else {
                toastMessage('Outlets not available', 'warning')
              }
            }}
          >
            Create Terminal
          </Button> */}
          <TerminalDialog
            visible={terminalDrawerVisibility}
            title={
              terminalDrawerMode == 'new'
                ? 'Create New Terminal'
                : 'Edit Terminal'
            }
            apps={getAppsForTerminalData}
            initialValues={terminalData}
            okText={terminalDrawerMode == 'new' ? 'Create' : 'Update'}
            outletData={outletFetchData.data}
            action={terminalDrawerMode}
            onCancel={() => setTerminalDrawerVisibility(false)}
            onSubmit={(value) => {
              let values = _.cloneDeep(value)
              if (values?.app_flavor) {
                delete values.app_flavor
              }
              if (terminalDrawerMode == 'new') {
                createTerminalOnline(values, (success, error, message) => {
                  if (error) {
                    setTerminalDrawerVisibility(true)
                    toastMessage(message, 'error')
                  } else {
                    setTerminalDrawerVisibility(false)
                    toastMessage('Terminal created successfully', 'success')
                    let payLoad = {
                      pageNumber: page,
                      limit: limit
                    }
                    fetchTerminalOnline(payLoad)
                  }
                })
              } else {
                values.id = terminalData?._id
                delete values._id
                delete values.business_id
                if (values?.outlet) values.outlet_id = values?.outlet?._id
                delete values.outlet
                delete values.key
                values.app_flavor_id = values?.app_flavor?._id
                if (values?.app_flavor) {
                  delete values.app_flavor
                }
                if (values?.app_flavor_id == undefined)
                  delete values.app_flavor_id
                updateTerminalOnline(values, (success, error, message) => {
                  if (error) {
                    setTerminalDrawerVisibility(true)
                    toastMessage(message, 'error')
                  } else {
                    setTerminalDrawerVisibility(false)
                    // Show hybrid activation message if hybrid was enabled
                    if (values.is_hybrid && !terminalData?.is_hybrid) {
                      toastMessage(
                        `Hybrid Billing successfully activated for ${terminalData?.name}`,
                        'success'
                      )
                    } else {
                      toastMessage('Terminal updated successfully', 'success')
                    }
                    let payLoad = {
                      pageNumber: page,
                      limit: limit
                    }
                    fetchTerminalOnline(payLoad)
                  }
                })
              }
            }}
          />
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />
      {outletFetchError || fetchTerminalOnlineError ? (
        <ErrorScreen
          onClick={() => {
            fetchTerminalOnError()
          }}
        />
      ) : (
        <div>
          {(outletFetchLoading || fetchTerminalOnlineLoading) && (
            <UserTypeShimmerWithoutAvatar body={true} />
          )}
          {(!outletFetchLoading &&
            !fetchTerminalOnlineLoading &&
            outletFetchData.data?.length <= 0) ||
            (fetchTerminalOnlineData.data?.length <= 0 && (
              <ShowNoRecordsFound />
            ))}

          {!fetchTerminalOnlineError &&
            !outletFetchError &&
            !outletFetchLoading &&
            !fetchTerminalOnlineLoading &&
            fetchTerminalOnlineData.data &&
            fetchTerminalOnlineData?.data.length > 0 && (
              <Grid container spacing={10} sx={{ paddingTop: 5 }}>
                <Grid item xs sm md>
                  <Box sx={{ margin: 2 }}>
                    <Card raised sx={{ borderRadius: 3 }}>
                      <CardContent>
                        <Grid
                          container
                          columns={6}
                          rowSpacing={3}
                          columnSpacing={3}
                        >
                          {fetchTerminalOnlineData.data?.map((row, index) => (
                            <Grid item xs={6} sm={3} md={2} key={index}>
                              <TerminalListUI terminal={row} index={index} />
                            </Grid>
                          ))}
                        </Grid>
                      </CardContent>
                      {pagecount > 1 && (
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            p: 2,
                            backgroundColor: 'grey.50',
                            borderRadius: 1
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              width: '100%'
                            }}
                          >
                            <Pagination
                              count={pagecount}
                              page={page}
                              color="secondary"
                              size="small"
                              boundaryCount={2}
                              siblingCount={0}
                              showFirstButton
                              showLastButton
                              onChange={handlePageChange}
                              sx={{
                                '& .MuiPaginationItem-root': {
                                  transition: 'all 0.2s ease-in-out'
                                }
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 1.5,
                              backgroundColor: 'white',
                              p: 2,
                              borderRadius: 1,
                              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                              transition: 'box-shadow 0.2s ease-in-out',
                              '&:hover': {
                                boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                              }
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ color: 'text.secondary', fontWeight: 500 }}
                            >
                              Jump to
                            </Typography>
                            <TextField
                              size="small"
                              value={goToPageInput}
                              onChange={handleGoToPageChange}
                              onKeyPress={handleGoToPageKeyPress}
                              placeholder="Page"
                              sx={{
                                width: '80px',
                                '& .MuiOutlinedInput-root': {
                                  backgroundColor: 'white',
                                  transition: 'all 0.2s ease-in-out',
                                  '& fieldset': {
                                    borderColor: 'grey.300',
                                    borderWidth: '1px'
                                  },
                                  '&:hover fieldset': {
                                    borderColor: 'secondary.main',
                                    borderWidth: '1.5px'
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: 'secondary.main',
                                    borderWidth: '2px',
                                    boxShadow:
                                      '0 0 0 3px rgba(156, 39, 176, 0.1)'
                                  }
                                },
                                '& .MuiOutlinedInput-input': {
                                  textAlign: 'center',
                                  fontWeight: 500,
                                  padding: '7px 8px',
                                  height: '20px',
                                  lineHeight: '20px'
                                }
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{ color: 'text.secondary', fontWeight: 400 }}
                            >
                              of {pagecount}
                            </Typography>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              onClick={handleGoToPageSubmit}
                              disabled={
                                !goToPageInput ||
                                parseInt(goToPageInput, 10) < 1 ||
                                parseInt(goToPageInput, 10) > pagecount
                              }
                              sx={{
                                textTransform: 'none',
                                fontWeight: 500,
                                px: 2,
                                py: 0.75,
                                height: '34px',
                                lineHeight: 1,
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                  transform: 'translateY(-1px)',
                                  boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                                },
                                '&:active': {
                                  transform: 'translateY(0)'
                                }
                              }}
                            >
                              Go
                            </Button>
                          </Box>
                        </Box>
                      )}
                    </Card>
                  </Box>
                </Grid>
              </Grid>
            )}
          <div>
            <Snackbar
              open={snackbar}
              autoHideDuration={SnackBarHideDuration}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              onClose={handleSnackbarClose}
              TransitionComponent={SnackBarTransition}
            >
              <Alert onClose={handleSnackbarClose} severity={severity}>
                {PopUpMessage}
              </Alert>
            </Snackbar>
          </div>
        </div>
      )}
    </>
  )
}
export default Terminal
